export default __webpack_public_path__ + "static/static-banner768-img-3742370c0e7473a2a15ff4e450a079ed.jpg";